import { get } from 'lodash';

import { Manifestation } from './manifestation-data-store';

export const expression = (manifestation: Manifestation) =>
    get(manifestation, ['linkToExpression', 'referentExpression']);
